import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, Button, ButtonGroup, Alert } from '@mui/material';
import { useOAuth } from '../../hooks/useOAuth';
import { getIsAuthenticated } from '../../redux/auth/selectors';
import { useAppSelector } from '../../hooks/reduxHooks';

export const SSOLogin: React.FC = () => {
  const { isLoading, handleAuthorize } = useOAuth();
  const isAuthenticated = useAppSelector(getIsAuthenticated);
  const hasAuthorized = useRef(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isAuthenticated && !hasAuthorized.current) {
      handleAuthorize(['cameras_user_info']).catch((err) => {
        setError(
          err?.response?.data?.message ||
            'Authorization failed. Please try again.'
        );
      });
      hasAuthorized.current = true;
    }
  }, [handleAuthorize, isAuthenticated]);

  if (!isAuthenticated) {
    return (
      <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4, p: 3, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Not Authenticated
        </Typography>
        <Typography variant="body1" gutterBottom>
          Please log in to continue.
        </Typography>
      </Box>
    );
  }
  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        {isLoading ? 'Authorizing...' : error ? '' : 'Ready'}
      </Typography>
      {isLoading && (
        <Typography variant="body1" gutterBottom>
          Please wait while we authorize your account...
        </Typography>
      )}
      {error && (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
          <Typography variant="h4" gutterBottom>
            Oops! Something went wrong.
          </Typography>
          <Typography variant="body1" align="center" gutterBottom>
            We apologize for the inconvenience. Please try reloading the page or
            go back to the home page.
          </Typography>
          <ButtonGroup>
            <Button
              variant="contained"
              color="primary"
              onClick={() => window.location.reload()}
            >
              Reload Page
            </Button>
            <Button
              variant="contained"
              sx={{ ml: 1 }}
              color="secondary"
              href="/"
            >
              Back to Home
            </Button>
          </ButtonGroup>
        </Box>
      )}
    </Box>
  );
};
